import { m } from "framer-motion";
import Image from "next/image";
import InternalLink from "@/components/ui/internal-link";
const Banner = () => {
  const data = [
    {
      title:
        "Consulting that Strengthens the Development Sector - Finance, Research and Climate Solutions for Informal Workers",
      description:
        "Soulscale, helps development organisations strengthen financial systems, ensure statutory compliance, and resolve complex challenges. Focus on driving impact—we’ll take care of your financial management.",
      image: "/images/Orange & Purple Geometric Tehnology Linkdln Banner.webp",
      buttonLink: "/about-us",
    },
  ];
  return (
    <div className="homeBanner w-full relative lg:h-screen md:h-[800px] h-screen">
      <div className="w-full lg:h-screen md:h-[800px] h-screen bg-[#fafafa] relative">
        <Image
          src={data[0]?.image}
          alt={data[0]?.title}
          fill
          priority
          sizes="(max-width: 479px) 100vw,(max-width: 768px) 100vw, (max-width: 1200px) 100vw,(max-width: 1920px) 100vw, 100vw"
          className="object-cover w-full h-full object-left"
        />
        <div
          className="absolute md:pt-0 pt-8 top-0 left-0 w-full h-full flex flex-col gap-2 justify-center px-[5vw]"
          style={{
            backgroundImage:
              "linear-gradient(90deg, rgb(45, 39, 106) 20%, rgba(45, 39, 106, 0.8) 40%, rgba(45, 39, 106, 0.4) 60%, rgba(0, 0, 0, 0) 80%)",
          }}
        >
          <m.h1
            initial={{ y: 40, opacity: 0 }}
            whileInView={{ y: 0, opacity: 100 }}
            transition={{ duration: 0.75, delay: 0.2 }}
            className="text-white font-medium"
          >
            {data[0]?.title}
          </m.h1>
          <m.p
            initial={{ y: 40, opacity: 0 }}
            whileInView={{ y: 0, opacity: 100 }}
            transition={{ duration: 0.75, delay: 0.4 }}
            className="text-white/90 lg:text-lg md:text-base text-sm lg:max-w-[600px] md:max-w-[500px] lg:leading-normal leading-tight mt-4"
          >
            {data[0]?.description}
          </m.p>
          <m.div
            initial={{ y: 40, opacity: 0 }}
            whileInView={{ y: 0, opacity: 100 }}
            transition={{ duration: 0.75, delay: 0.4 }}
            className="lg:mt-8 mt-6"
          >
            <InternalLink
              href="/about-us"
              className="min-w-[150px]"
              variant="lightBlue"
            >
              About Us
            </InternalLink>
          </m.div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
